import { Receipt } from "@/types/entities";

export const uploadFileAndGetJsonResponse = async (
  file: File,
  processFile: (file: File) => Promise<{ type: string; content: Blob }>,
  userId: string = "unknown"
): Promise<{ jsonResponse: Receipt; responseTime: number }> => {
  const startTime = new Date().getTime();

  const processedFile = await processFile(file);

  const formData = new FormData();
  formData.append("file", processedFile.content, file.name);
  formData.append("fileType", processedFile.type);
  formData.append("userId", userId);

  // Add text content if the file is text
  if (processedFile.type === "text") {
    const text = await processedFile.content.text();
    formData.append("textContent", text);
  }

  const response = await fetch(
    "https://sgpvdvssamjteabckoft.supabase.co/functions/v1/receipt-data",
    {
      method: "POST",
      headers: {
        "X-Bridge23-Env": import.meta.env.PROD ? "production" : "local",
      },
      body: formData,
    }
  );

  const endTime = new Date().getTime();
  const timeTaken = endTime - startTime;

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  const data = await response.json();
  console.log("data", data);
  const clearJsonResponse = extractJsonFromResponse(data);

  return { jsonResponse: clearJsonResponse, responseTime: timeTaken };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const extractJsonFromResponse = (response: any): any => {
  const content = response.responseResult.choices[0].message.content;
  const startIndex = content.indexOf("{");
  const endIndex = content.lastIndexOf("}") + 1;
  const jsonString = content.slice(startIndex, endIndex);

  try {
    const jsonResponse = JSON.parse(jsonString);
    return jsonResponse;
  } catch (error) {
    console.error("Failed to parse JSON", error);
    return null;
  }
};
